import { useEffect } from 'react';
import { useThemeStore, resolveTheme } from '@shared/lib';

/**
 * Liest das Theme aus dem Zustand Store und setzt `data-theme` auf dem `<html>`-Element.
 * Reagiert auch auf Systemänderungen wenn "system" ausgewählt ist.
 *
 * Muss einmalig in der App-Root eingebunden werden, erzeugt kein DOM-Element.
 *
 * @example
 * ```tsx
 * <ThemeProvider />
 * ```
 */
export function ThemeProvider() {
  const theme = useThemeStore((s) => s.theme);

  useEffect(() => {
    const apply = () => {
      const resolved = resolveTheme(theme);
      document.documentElement.setAttribute('data-theme', resolved);
    };

    apply();

    if (theme === 'system') {
      const mql = window.matchMedia('(prefers-color-scheme: dark)');
      mql.addEventListener('change', apply);
      return () => mql.removeEventListener('change', apply);
    }
  }, [theme]);

  return null;
}
